import { __assign } from 'tslib';
import { jsxs, jsx } from 'react/jsx-runtime';
import { useContext } from 'react';
import { Helmet } from 'react-helmet';
import { ThemeProvider } from '@emotion/react';
import { LinkComponentContext } from './linkComponentContext.js';
export { DefaultLinkComponent, LinkComponentContext, contextError, makeLinkComponent, useLinkComponent } from './linkComponentContext.js';
import { theme } from '@compono/ui-theme-compono';
import { DetectInputMethodProvider } from '../hooks/useDetectInputMethod.js';
import { Toaster } from '../Toaster/Toaster.js';
import { CSSVars } from './CSSVars.js';
import { WebFonts } from './WebFonts.js';

function UIProvider(_a) {
    var children = _a.children, _b = _a.theme, theme$1 = _b === void 0 ? theme : _b, linkComponent = _a.linkComponent, _c = _a.enableFavicon, enableFavicon = _c === void 0 ? true : _c;
    var linkComponentFromContext = useContext(LinkComponentContext);
    return (jsxs(DetectInputMethodProvider, { children: [enableFavicon && (jsx(Helmet, { children: jsx("link", { rel: "icon", type: "image/png", href: "https://ui.compono.dev/favicon.png", sizes: "192x192" }) })), jsx(WebFonts, { theme: theme$1 }), jsx(CSSVars, { theme: theme$1 }), jsx(ThemeProvider, __assign({ theme: theme$1 }, { children: jsxs(LinkComponentContext.Provider, __assign({ value: linkComponent || linkComponentFromContext }, { children: [jsx(Toaster, {}), children] })) }))] }));
}

export { UIProvider };
//# sourceMappingURL=UIProvider.js.map
